module.exports = __webpack_public_path__ + "app/global-setting/global-setting-1l_A5N9U.html";